/**
 * The FAQs for /tools, in their own module.
 *
 * A route's `head` is never code-split, so importing this from the page
 * component would pull the whole page into the shared entry chunk that every
 * visitor downloads — the trap `marketing-perf-ceiling` documents and the
 * Mastodon limit checker was caught by.
 *
 * Rendered visibly on the page AND emitted as `FAQPage` JSON-LD.
 */
export const TOOLS_INDEX_FAQS = [
  {
    q: "Are these tools really free?",
    a: "Yes, and there is no account, no email and no trial. They are here because we build a social scheduler and these are the questions we had to answer properly to build it — the counting rules, the per-server limits, the video formats each network rejects. Publishing the answers costs us nothing and saves you an afternoon.",
  },
  {
    q: "Do I have to connect an account?",
    a: "No. Nothing here uses OAuth, an app password or an API key. The tools that read an account only ever read what is already public — the same posts anyone can see by visiting the profile — and they read it straight from Bluesky's or your Mastodon server's own public API.",
  },
  {
    q: "Does anything I type or upload get stored?",
    a: "The thread splitter and the video checker never send your content anywhere at all: the draft is split and the video file is inspected inside your browser, so neither leaves your machine. The account tools call the network's public API directly from your browser rather than through our servers, so we never see a handle or a server name. We do count that a tool was used, which records no part of what you put into it.",
  },
  {
    q: "Why do these counts differ from the box I normally type in?",
    a: "Because most editors count characters in the string and no network does. X weights every link at 23 however long it is, and emoji and CJK characters at 2. Bluesky counts grapheme clusters — a family emoji is one character, not eleven — and enforces a separate 3,000-byte ceiling underneath. Mastodon's limit is set per server and makes the server half of a remote mention free. These tools use the same counting functions our publisher uses.",
  },
  {
    q: "Can I use these if I do not use PostDaily?",
    a: "Yes. Nothing here is gated, rate-limited by plan or degraded for signed-out visitors, and none of it asks you to sign up before showing a result. If a tool saves you enough time that scheduling the post is the next annoyance, the product is there — but that is the only connection.",
  },
] as const;
